import "./index.css";
import React from "react";

export default function RadioOption({
  option,
  onClick,
  checked,
  hex,
  disabled,
}) {
  return (
    <label
      className="radio-option__label"
      htmlFor={option.id}
      onClick={() => onClick(option)}
    >
      {option.label}
      <input
        type="radio"
        className="radio-option__input"
        id={option.id}
        defaultChecked={checked}
        disabled={disabled}
      />
      <div className="radio-option__custom-input-container">
        <div
          className={`radio-option__custom-input
           ${
             checked
               ? "radio-option__custom-input--checked"
               : "radio-option__custom-input--hover"
           }`}
          style={{ "--checkedColor": hex }}
        ></div>
      </div>
    </label>
  );
}



// WEBPACK FOOTER //
// ./src/screens/super_products/components/Popup/components/RadioGroup/components/RadioOption/index.js